import React from 'react';
import publicationsData from '../publications.json';
import './Publications.css';

// Content is edited in src/publications.json
const POSTERS = publicationsData.posters;
const PUBLICATIONS = publicationsData.publications;

// Parses an author string: **bold** (lab PI) and __underlined__ (trainee authors)
const renderAuthors = (authors) => {
  const parts = String(authors).split(/(\*\*[^*]+\*\*|__[^_]+__)/g);
  return parts.map((part, i) => {
    if (!part) return null;
    if (part.startsWith('**') && part.endsWith('**')) {
      return <strong key={i}>{part.slice(2, -2)}</strong>;
    }
    if (part.startsWith('__') && part.endsWith('__')) {
      return <span key={i} className="pub-trainee">{part.slice(2, -2)}</span>;
    }
    return <React.Fragment key={i}>{part}</React.Fragment>;
  });
};

function Publications() {
  return (
    <div className="page publications-page">
      <div className="container-narrow">
        <header className="page-header">
          <h1>Research and Publications</h1>
          <div className="accent-bar"></div>
        </header>

        <section className="research-section">
          <h2 className="section-heading">Learn more about our recent research!</h2>
          <p className="section-subheading">
            Check out our one-page summaries of our latest findings!
          </p>

          <div className="posters-grid">
            {POSTERS.map((poster, idx) => (
             <a 
                key={idx}
                href={poster.file}
                target="_blank"
                rel="noopener noreferrer"
                className="poster-card"
              >
                <div className="poster-icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
                    <polyline points="14 2 14 8 20 8"></polyline>
                    <line x1="16" y1="13" x2="8" y2="13"></line>
                    <line x1="16" y1="17" x2="8" y2="17"></line>
                    <polyline points="10 9 9 9 8 9"></polyline>
                  </svg>
                </div>
                <h3 className="poster-title">{poster.title}</h3>
                <p className="poster-description">{poster.description}</p>
                <p className="poster-authors">{poster.authors}</p>
                <span className="poster-link">
                  View PDF
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <line x1="5" y1="12" x2="19" y2="12"></line>
                    <polyline points="12 5 19 12 12 19"></polyline>
                  </svg>
                </span>
              </a>
            ))}
          </div>
        </section>

        <section className="publications-section">
          <h2 className="section-heading">Select Publications</h2>
          <p className="section-subheading">
            Trainee authors are <span className="pub-trainee">underlined</span>.
          </p>

          <ol className="pub-list">
            {PUBLICATIONS.map((pub, idx) => {
              const isNewYear = idx > 0 && pub.year !== PUBLICATIONS[idx - 1].year;
              return (
                <li
                  key={idx}
                  className={`pub-item${isNewYear ? ' pub-item-year-break' : ''}`}
                >
                  <p className="pub-authors">
                    {renderAuthors(pub.authors)} ({pub.year})
                  </p>
                  <p className="pub-title">{pub.title}.</p>
                  <p className="pub-journal">
                    <em>{pub.journal}</em> {pub.citation}.
                  </p>
                </li>
              );
            })}
          </ol>
        </section>
      </div>
    </div>
  );
}

export default Publications;